export const BOOKING_ERROR_TYPES = {
  PRICE_CHANGED: 'PRICE_CHANGED',
  TIME_EXPIRED: 'TIME_EXPIRED',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  GENERIC: 'GENERIC',
};

export const ERROR_COPY = {
  [BOOKING_ERROR_TYPES.PRICE_CHANGED]: {
    title: 'Falló la creación por cambio de tarifa',
    message:
      'El hotel realizó un cambio en la tarifa. Por favor, realiza una nueva búsqueda para continuar con tu reserva.',
  },
  [BOOKING_ERROR_TYPES.TIME_EXPIRED]: {
    title: 'Falló la creación de tu reserva',
    message:
      'Pasó mucho tiempo desde que hiciste tu búsqueda. Te pedimos que intentes nuevamente.',
  },
  [BOOKING_ERROR_TYPES.PAYMENT_ERROR]: {
    title: 'Falló la creación de tu reserva',
    message: ({ isSucursal }) =>
      isSucursal
        ? 'Dirígete a tu sucursal seleccionada para chequear el estado de tu reserva y volver a tomarla.'
        : 'Comunicate con tu vendedor de confianza para chequear el estado de tu reserva y volver a tomarla.',
  },
};
